import { GET_TAGS, CREATE_TAG, UPDATE_TAG, DELETE_TAG } from './tag.types';

export const tagActions = {
  getTags: (params) => ({
    type: GET_TAGS,
    payload: params,
  }),
  createTag: (data) => ({
    type: CREATE_TAG,
    payload: data,
  }),
  updateTag: (id, data) => ({
    type: UPDATE_TAG,
    payload: { id, data },
  }),
  deleteTag: (id) => ({
    type: DELETE_TAG,
    payload: id,
  }),
};
